import { useLang } from "@/i18n";

const ITEMS = [
  "M&A Advisory",
  "Fiscalità Internazionale",
  "Governance & ESG",
  "Ristrutturazioni del Debito",
  "Family Office",
  "Transfer Pricing",
  "Due Diligence",
  "Passaggio Generazionale",
];

export default function Marquee() {
  const { t } = useLang();
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="marquee-hover-pause relative overflow-hidden border-y border-gold/15 bg-navy-900/60 py-5"
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="px-8 font-mono text-xs uppercase tracking-[0.35em] text-slate-400">
                  {t(item)}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
